import { render } from "./ManagerApplications.vue?vue&type=template&id=72d15b43"
import script from "./ManagerApplications.vue?vue&type=script&lang=js"
export * from "./ManagerApplications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__